import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <header
      className="border-b border-[#E6E6E4] bg-white px-8 py-6 flex items-start justify-between gap-6"
      data-testid={testid || "page-header"}
    >
      <div>
        <h1 className="font-display font-extrabold text-2xl sm:text-3xl tracking-tight text-[#1A1A1A]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-sm text-[#5C5E60]">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}

export function StatusBadge({ variant = "info", children, testid }) {
  const map = {
    success: "bg-[#E8F5E9] text-[#1E4620]",
    error: "bg-[#FCE8E8] text-[#B31D1D]",
    warning: "bg-[#FFF4E5] text-[#915000]",
    info: "bg-[#EAF4FA] text-[#1A4971]",
    neutral: "bg-[#F3F3F1] text-[#5C5E60]",
  };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${map[variant] || map.info}`}
    >
      {children}
    </span>
  );
}

export function KpiCard({ label, value, sublabel, tone = "default", testid }) {
  const toneMap = {
    default: "text-[#1A1A1A]",
    warning: "text-[#915000]",
    error: "text-[#B31D1D]",
    success: "text-[#1E4620]",
  };
  return (
    <div
      className="bg-white border border-[#E6E6E4] rounded-md p-5 flex flex-col gap-2"
      data-testid={testid}
    >
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#5C5E60] font-semibold">{label}</div>
      <div className={`font-display font-extrabold text-3xl leading-none tracking-tight ${toneMap[tone]}`}>{value}</div>
      {sublabel && <div className="text-xs text-[#5C5E60]">{sublabel}</div>}
    </div>
  );
}

export function EmptyState({ title, hint, action, testid }) {
  return (
    <div
      className="border border-dashed border-[#E6E6E4] rounded-lg p-12 text-center bg-white"
      data-testid={testid || "empty-state"}
    >
      <div className="font-display font-bold text-lg text-[#1A1A1A]">{title}</div>
      {hint && <div className="mt-1 text-sm text-[#5C5E60]">{hint}</div>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}

export function PrimaryButton({ children, ...props }) {
  return (
    <button
      {...props}
      className={`inline-flex items-center gap-2 bg-[#18322B] text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-[#21453B] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed ${props.className || ""}`}
    >
      {children}
    </button>
  );
}

export function SecondaryButton({ children, ...props }) {
  return (
    <button
      {...props}
      className={`inline-flex items-center gap-2 bg-white border border-[#E6E6E4] text-sm text-[#1A1A1A] px-4 py-2 rounded-md hover:bg-[#F3F3F1] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed ${props.className || ""}`}
    >
      {children}
    </button>
  );
}
